(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["event-booking-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('event-booking-fields')) {
    customElements.define('event-booking-fields', class extends HTMLElement {
      connectedCallback() {
        const date = this.querySelector('[data-event-date]');
        const start = this.querySelector('[data-start-time]');
        const finish = this.querySelector('[data-finish-time]');
        const form = this.closest('form');
        const localToday = new Date();
        localToday.setMinutes(localToday.getMinutes() - localToday.getTimezoneOffset());
        date.min = localToday.toISOString().slice(0, 10);

        const blocked = (this.dataset.blockedDates || '')
          .split(/[\s,]+/)
          .map((value) => value.trim())
          .filter(Boolean);

        const validateDate = () => {
          this.querySelector('[data-setup-date]').value = date.value;
          this.querySelector('[data-setup-date-output]').textContent = date.value ? date.value.split('-').reverse().join('/') : '—';
          date.setCustomValidity(blocked.includes(date.value) ? this.dataset.dateError : '');
        };

        const setupStart = this.querySelector('[data-setup-start]');
        const packStart = this.querySelector('[data-pack-start]');
        const packEnd = this.querySelector('[data-pack-end]');
        const timeline = this.querySelector('[data-timeline]');
        const empty = this.querySelector('[data-timeline-empty]');
        const timeValue = (minutes) => `${String((Math.floor(minutes / 60) % 24)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
        const timeSuffix = (minutes) => {
          const days = Math.floor(minutes / 1440);
          if (days < 1) return '';
          if (days === 1) return ' ' + this.dataset.nextDay;
          const day = new Date(date.value + 'T00:00:00Z');
          if (Number.isNaN(day.getTime())) return ' ' + (this.dataset.daysLater || '__days__ days later').replace('__days__', String(days));
          day.setUTCDate(day.getUTCDate() + days);
          return ' ' + day.toISOString().slice(0, 10).split('-').reverse().join('/');
        };
        const displayTime = (minutes) => `${Math.floor(minutes / 60) % 12 || 12}:${String(minutes % 60).padStart(2, '0')} ${minutes % 1440 < 720 ? 'AM' : 'PM'}${timeSuffix(minutes)}`;
        const updateFinishTime = () => {
          const hireLabel = this.querySelector('[data-booking-hire-label]');
          const hireChoice = this.querySelector('[data-hire-duration]')?.selectedOptions[0];
          if (hireLabel) hireLabel.textContent = hireChoice?.textContent.trim() || '';
          const [hours, minutes] = start.value.split(':').map(Number);
          const active = hours * 60 + minutes;
          const valid = /^\d{2}:\d{2}$/.test(start.value) && active >= 540 && active <= 1260 && active % 15 === 0;
          start.setCustomValidity(start.value && !valid ? this.dataset.timeError : '');
          timeline.hidden = !valid;
          empty.hidden = valid;
          if (!valid) {
            [setupStart, finish, packStart, packEnd].forEach((field) => { field.value = ''; });
            return;
          }
          const setup = active - 120;
          const duration = Number(this.querySelector('[data-hire-duration]')?.value || 3);
          const pack = active + duration * 60;
          this.querySelector('[data-event-duration]').value = duration + ' hours active hire';
          const activeLabel = this.querySelector('[data-active-label]');
          activeLabel.textContent = activeLabel.dataset.label.replace('__hours__', String(duration));
          const complete = pack + 60;
          setupStart.value = timeValue(setup);
          finish.value = timeValue(pack) + timeSuffix(pack);
          packStart.value = finish.value;
          packEnd.value = timeValue(complete) + timeSuffix(complete);
          this.querySelector('[data-setup-output]').textContent = `${displayTime(setup)} – ${displayTime(active)}`;
          this.querySelector('[data-active-output]').textContent = `${displayTime(active)} – ${displayTime(pack)}`;
          this.querySelector('[data-pack-output]').textContent = `${displayTime(pack)} – ${displayTime(complete)}`;
        };

        date.addEventListener('change', () => { validateDate(); updateFinishTime(); });
        date.addEventListener('input', () => { validateDate(); updateFinishTime(); });
        validateDate();
        window.OlouiooEvents?.hydrate(this);
        ['input', 'change'].forEach((eventName) => {
          start.addEventListener(eventName, updateFinishTime);
        });
        updateFinishTime();
        form?.addEventListener('submit', (event) => {
          validateDate();
          updateFinishTime();
          if (!date.reportValidity() || !start.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

        }, true);
      }
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-event-enquiry-tier],[data-hire-enquiry]');
    if (!link) return;
    const booking = link.closest('event-booking-fields');
    if (!booking) return;
    const form = booking?.closest('product-form-component');
    const url = new URL(link.href, location.origin);
    url.searchParams.set('service', booking.dataset.serviceTitle);
    url.searchParams.set('service_handle', booking.dataset.serviceHandle);
    if (link.dataset.eventEnquiryTier) url.searchParams.set('guest_tier', link.dataset.eventEnquiryTier);
    const checked = [...document.querySelectorAll('input[type="radio"]:checked')].map(input => input.value);
    const finish = checked.find(value => /^(Glass|Premium acrylic)/i.test(value));
    const drinks = checked.find(value => /Mango Jasmine|Pomegranate Lychee|Butterfly Lychee Bloom|All three drinks/.test(value));
    if (finish) url.searchParams.set('finish',finish);
    if (drinks) url.searchParams.set('drinks',drinks);
    const date = booking.querySelector('[data-event-date]')?.value;
    const time = booking.querySelector('[data-start-time]')?.value;
    if (date) url.searchParams.set('date',date);
    if (time) url.searchParams.set('time',time);
    location.href = url.toString();
    event.preventDefault();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lor-preview-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lor-preview-gallery'))customElements.define('lor-preview-gallery',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const b=event.target.closest('[data-lor-thumb]');if(!b||!this.contains(b))return;const index=Number(b.dataset.lorThumb);this.querySelectorAll('[data-lor-slide]').forEach((s,i)=>s.hidden=i!==index);this.querySelectorAll('[data-lor-thumb]').forEach((t,i)=>t.setAttribute('aria-pressed',String(i===index)));});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-book-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-book-choice')) {
  customElements.define('olouioo-book-choice', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-book-choice]');
        if (!trigger || trigger.dataset.bookChoice !== this.dataset.kind) return;
        event.preventDefault();
        this.trigger = trigger;
        if (!dialog.open) dialog.showModal();
      }, options);
      this.querySelector('.obc-close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.trigger?.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-drink-journey"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-drink-journey')) {
  customElements.define('olouioo-drink-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this.closest('.olouioo-signature-drink');
      const details = root?.querySelector('.product-information__details-wrapper');
      const picker = details?.querySelector('variant-picker');
      const buy = details?.querySelector('.buy-buttons-block');
      if (!root || !details || !picker || !buy) return;
      const actions = this.querySelector('[data-actions]');
      const groups = () => [...picker.querySelectorAll('.variant-option[role="group"]')];
      details.insertBefore(this, picker);
      buy.after(actions);
      const form = buy.querySelector('form');
      const copy = JSON.parse(this.querySelector('[data-stage-copy]').textContent);
      const variants = JSON.parse(this.querySelector('[data-drink-variants]').textContent);
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency || 'AUD'});
      let step = 1;
      const selected = () => groups().map(group => group.querySelector('input:checked')?.value || group.querySelector('select')?.value || '');
      const updateReview = () => {
        const options = selected();
        const variant = variants.find(item => item.options.every((value,index) => value === options[index]));
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant?.available ? String(variant.id) : '';
        const add = form.querySelector('.add-to-cart-button');
        if (add) add.disabled = !variant?.available;
        const qty = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
        const date = form.querySelector('[data-event-date]')?.value || '—';
        const time = form.querySelector('[data-start-time]')?.value || '';
        const venue = form.querySelector('[data-event-venue]')?.value.trim() || '—';
        this.querySelector('[data-summary-drink]').textContent = options[0] || '—';
        this.querySelector('[data-summary-finish]').textContent = options.slice(1).join(' · ');
        this.querySelector('[data-summary-event]').textContent = `${date}${time ? ' · ' + time : ''} · ${venue}`;
        this.querySelector('[data-summary-quantity]').textContent = String(qty);
        this.querySelector('[data-summary-total]').textContent = variant ? money.format(variant.price * qty / 100) : '—';
      };
      const show = value => {
        step = value;
        root.classList.remove('odjourney-stage-1','odjourney-stage-2','odjourney-stage-3','odjourney-stage-4');
        root.classList.add(`odjourney-stage-${step}`);
        groups().forEach((group,index) => { group.hidden = step === 1 ? index !== 0 : step === 2 ? index === 0 : true; });
        const about = picker.querySelector('.olouioo-drink-info');
        if (about) about.hidden = step !== 1;
        this.querySelector('[data-stage-title]').textContent = copy.titles[step - 1];
        this.querySelector('[data-stage-description]').textContent = copy.hints[step - 1];
        this.querySelectorAll('[data-go]').forEach(button => {
          if (Number(button.dataset.go) === step) button.setAttribute('aria-current','step');
          else button.removeAttribute('aria-current');
        });
        this.querySelector('[data-review]').hidden = step !== 4;
        actions.querySelector('[data-back]').hidden = step === 1;
        actions.querySelector('[data-next]').hidden = step === 4;
        updateReview();
      };
      const navigate = value => {
        if (value === 4 && step === 3) {
          const date = form.querySelector('[data-event-date]');
          date?.dispatchEvent(new Event('change', {bubbles:true}));
          for (const field of ['[data-event-date]','[data-start-time]','[data-event-venue]']) {
            if (!form.querySelector(field)?.reportValidity()) return;
          }
        }
        show(value);
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      };
      actions.querySelector('[data-back]').addEventListener('click',() => navigate(Math.max(1,step-1)));
      actions.querySelector('[data-next]').addEventListener('click',() => navigate(Math.min(4,step+1)));
      this.querySelectorAll('[data-go]').forEach(button => button.addEventListener('click',() => navigate(Number(button.dataset.go))));
      picker.addEventListener('change', updateReview);
      form.addEventListener('input', updateReview);
      form.addEventListener('change', updateReview);
      form.querySelector('.add-to-cart-button')?.addEventListener('click', updateReview, true);
      show(1);
      if (groups().length < 3) {
        const observer = new MutationObserver(() => {
          if (groups().length < 3) return;
          observer.disconnect();
          show(step);
        });
        observer.observe(picker, {childList:true,subtree:true});
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-drinks-page"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('olouioo-drink-tabs')){
  customElements.define('olouioo-drink-tabs',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const tabs=[...this.querySelectorAll('[data-drink-tab]')];
      const panels=[...this.querySelectorAll('[data-drink-panel]')];
      const list=this.querySelector('[data-drink-tabs]');
      if(!list||tabs.length!==panels.length)return;
      list.setAttribute('role','tablist');
      tabs.forEach((tab,index)=>{
        tab.setAttribute('role','tab');
        panels[index].setAttribute('role','tabpanel');
        panels[index].setAttribute('aria-labelledby',tab.id);
        panels[index].tabIndex=0;
        tab.addEventListener('click',()=>select(index,false));
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=tabs.length-1;
          if(next!==undefined){event.preventDefault();select(next,true)}
        });
      });
      const centerTab=(index,smooth)=>{
        if(!window.matchMedia('(max-width:600px)').matches){list.style.paddingInline='';return;}
        list.style.paddingInlineStart=Math.max(0,(list.clientWidth-tabs[0].offsetWidth)/2)+'px';
        list.style.paddingInlineEnd=Math.max(0,(list.clientWidth-tabs[tabs.length-1].offsetWidth)/2)+'px';
        const tab=tabs[index];
        const left=list.scrollLeft+tab.getBoundingClientRect().left-list.getBoundingClientRect().left-(list.clientWidth-tab.offsetWidth)/2;
        list.scrollTo({left,behavior:smooth&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
      };
      const select=(index,focus)=>{
        this.closest('.odrinks').dataset.flavour=String(index+1);
        document.body.style.setProperty('--odrinks-page-bg',['#f5d886','#eec1cb','#d9c7ec'][index]);
        tabs.forEach((tab,i)=>{
          tab.setAttribute('aria-selected',String(i===index));
          tab.tabIndex=i===index?0:-1;
          panels[i].hidden=i!==index;
        });
        if(focus)tabs[index].focus();
        if(!list.hidden)centerTab(index,true);
      };
      let touchStart=null;
      this.querySelector('.odrinks__panels')?.addEventListener('touchstart',event=>{touchStart={x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}},{passive:true});
      this.querySelector('.odrinks__panels')?.addEventListener('touchend',event=>{
        if(!touchStart)return;
        const dx=event.changedTouches[0].clientX-touchStart.x;
        const dy=event.changedTouches[0].clientY-touchStart.y;
        touchStart=null;
        if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.4){
          const current=Number(this.closest('.odrinks').dataset.flavour)-1;
          select((current+(dx<0?1:tabs.length-1))%tabs.length,false);
        }
      },{passive:true});
      select(0,false);
      list.hidden=false;
      requestAnimationFrame(()=>centerTab(0,false));
      window.addEventListener('resize',()=>{
        const current=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');
        centerTab(Math.max(0,current),false);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-event-addons"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('[data-oea-carousel]').forEach(carousel => {
      if (carousel.dataset.oeaReady === 'true') return;
      carousel.dataset.oeaReady = 'true';
      const track = carousel.querySelector('.oea__grid');
      const cards = [...track.querySelectorAll('.oea-card')];
      const previous = carousel.querySelector('[data-oea-previous]');
      const next = carousel.querySelector('[data-oea-next]');
      const position = carousel.querySelector('[data-oea-position]');
      const viewOptions = carousel.parentElement.querySelector('.oea__view-options');
      const gridButton = viewOptions.querySelector('[data-oea-grid]');
      const singleButton = viewOptions.querySelector('[data-oea-single]');
      if (!cards.length) return;
      let index = 0;
      const update = () => {
        const trackLeft = track.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        cards.forEach((card, i) => {
          const delta = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (delta < distance) { distance = delta; closest = i; }
        });
        index = closest;
        position.textContent = `${index + 1} / ${cards.length}`;
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };
      const move = change => {
        const target = cards[Math.max(0, Math.min(cards.length - 1, index + change))];
        track.scrollTo({ left: track.scrollLeft + target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const setView = single => {
        carousel.classList.toggle('is-single', single);
        gridButton.setAttribute('aria-pressed', String(!single));
        singleButton.setAttribute('aria-pressed', String(single));
        track.scrollLeft = 0;
        update();
      };
      gridButton.addEventListener('click', () => setView(false));
      singleButton.addEventListener('click', () => setView(true));
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-hosted"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-hosted')) {
  customElements.define('olouioo-hosted', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-hosted-data]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.data.currency || 'AUD'});
      this.querySelectorAll('[data-enhanced]').forEach(el => el.hidden = false);
      this.planDialog = this.querySelector('.oh-plan-dialog');
      this.planLaunch = this.querySelector('[data-plan-launch]');
      this.planLaunch.addEventListener('click', () => this.openPlanner());
      this.querySelector('[data-plan-close]').addEventListener('click', () => this.planDialog.close());
      this.planDialog.addEventListener('click', event => { if (event.target === this.planDialog) this.planDialog.close(); });
      this.planDialog.addEventListener('close', () => this.planLaunch.focus({preventScroll:true}));
      this.querySelectorAll('a[href="#oh-plan"]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); this.openPlanner(); }));
      this.experience = this.querySelector('[data-experience]');
      this.experience.addEventListener('change', () => this.selectProduct(this.experience.value));
       this.querySelectorAll('[data-style-choice]').forEach(choice => choice.addEventListener('change', () => { if (choice.checked) this.selectProduct(choice.value); }));
       this.querySelectorAll('[data-option-choice]').forEach(choice => choice.addEventListener('change', () => { if (choice.closest('.oh-guest-choices')) this.customGuests = ''; const select = this.querySelector('#'+choice.dataset.selectId); select.value = choice.value; select.dispatchEvent(new Event('change', {bubbles:true})); }));
       this.querySelectorAll('[data-enquiry-tier]').forEach(choice => choice.addEventListener('change', () => { this.customGuests = choice.value; this.updateSummary(); }));
      this.querySelectorAll('[data-option]').forEach(el => el.addEventListener('change', () => this.updateSummary()));
      this.querySelectorAll('[data-drink-choice]').forEach(choice => choice.addEventListener('change', () => {
        const select = this.querySelector('#'+choice.dataset.selectId);
        select.value = choice.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      this.querySelectorAll('[data-configure]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault(); this.selectProduct(link.dataset.configure); this.openPlanner();
      }));
      this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
        const card = button.closest('[data-service-card]');
        card.dataset.detail = String(button.dataset.view === 'detail');
        card.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        card.querySelector('[data-gallery-caption]').textContent = this.data.messages[button.dataset.view];
      }));

      this.detailsDialog = this.querySelector('.oh-details-dialog');
      this.querySelectorAll('[data-card-details]').forEach(button => button.addEventListener('click', () => {
        const card = button.closest('.oh-card');
        this.detailsDialog.querySelector('#oh-details-title').textContent = card.querySelector('h3').textContent + ' · What’s included';
        this.detailsDialog.querySelector('.oh-details-dialog-content').innerHTML = card.querySelector('.oh-card-details-content').innerHTML;
        this.detailsDialog.showModal();
      }));
      this.querySelector('[data-close-details]').addEventListener('click', () => this.detailsDialog.close());
      this.detailsDialog.addEventListener('click', event => { if (event.target === this.detailsDialog) this.detailsDialog.close(); });
      this.selectProduct(this.experience.value);
      const eventDate = this.querySelector('[data-event-date]');
      const today = new Date();
      eventDate.min = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0,10);
      const dateDisplay = this.querySelector('.oh-date-placeholder');
      const datePrompt = dateDisplay.textContent.trim();
      const syncDateDisplay = () => {
        dateDisplay.textContent = eventDate.value
          ? new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(eventDate.value + 'T00:00:00Z'))
          : datePrompt;
        dateDisplay.classList.toggle('is-selected', Boolean(eventDate.value));
      };
      eventDate.addEventListener('change', syncDateDisplay);
      eventDate.addEventListener('input', syncDateDisplay);
      syncDateDisplay();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => this.classList.toggle('oh-planner-visible', entry.isIntersecting), {rootMargin:'0px 0px -80px 0px'}).observe(this.querySelector('#oh-plan'));
      }
      const timeSelect = this.querySelector('[data-event-time]');
      for (let hour = 9; hour <= 21; hour++) for (const minute of [0,30]) {
        if (hour === 21 && minute === 30) continue;
        const value = String(hour).padStart(2,'0') + ':' + String(minute).padStart(2,'0');
        const option = document.createElement('option'); option.value = value;
        option.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:'UTC'}).format(new Date(Date.UTC(2020,0,1,hour,minute)));
        timeSelect.append(option);
      }
      timeSelect.addEventListener('change', () => this.updateEventFinish());
      this.querySelector('[data-add-cart]').addEventListener('click', () => this.addSelectedPackage());
      this.querySelector('[data-open-enquiry]').addEventListener('click', () => {
        const details = this.querySelector('[data-enquiry]'); details.open = true;
        this.querySelector('[data-open-enquiry]').setAttribute('aria-expanded','true');
        details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
        details.querySelector('[name="contact[name]"]')?.focus({preventScroll:true});
      });
      this.querySelector('#HostedPackageEnquiry')?.addEventListener('submit', event => {
        if (!this.validateEvent()) { event.preventDefault(); return; }
        this.populateEnquiry();
      });
      if (this.querySelector('.oh-enquiry-success,.oh-package-enquiry .oh-action-error')) this.querySelector('[data-enquiry]').open = true;
      this.initPlannerStages();
      if (location.hash === '#oh-plan' || this.querySelector('.oh-enquiry-success,.oh-package-enquiry .oh-action-error')) this.openPlanner();
      this.form = this.querySelector('[data-finder]'); this.steps = [...this.querySelectorAll('[data-step]')]; this.results = this.querySelector('[data-results]'); this.step = 0; this.showStep(false);
      this.form.addEventListener('submit', event => {
        event.preventDefault(); if (!this.form.reportValidity()) return;
        if (this.step < this.steps.length - 1) { this.step++; this.showStep(true); return; }
        this.recommendation = {handle:this.form.querySelector('[name="oh-style"]:checked').value,guests:this.form.querySelector('[name="oh-guests"]').value,scope:this.form.querySelector('[name="oh-scope"]:checked').value};
        const key = this.recommendation.guests === 'large' || this.recommendation.scope === 'custom' ? 'custom' : this.recommendation.handle;
        this.querySelectorAll('[data-result]').forEach(panel => panel.hidden = panel.dataset.result !== key);
        const customLink = this.querySelector('[data-custom-result]');
        if (customLink) { const url = new URL(customLink.href, location.origin); url.searchParams.set('service', this.data.products.find(p => p.handle === this.recommendation.handle)?.title || ''); url.searchParams.set('guest_tier', this.recommendation.guests === 'large' ? 'More than 70 guests' : 'Up to '+this.recommendation.guests+' guests'); customLink.href = url.toString(); }
        this.form.hidden = true; this.results.hidden = false; this.results.focus({preventScroll:true});
      });
      this.querySelector('[data-back]').addEventListener('click', () => {this.step = Math.max(0,this.step-1);this.showStep(true);});
      this.querySelector('[data-restart]').addEventListener('click', () => {this.form.reset();this.step=0;this.form.hidden=false;this.results.hidden=true;this.showStep(true);});
      this.querySelectorAll('[data-use-result]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault(); this.selectProduct(link.dataset.useResult,this.recommendation?.guests); this.openPlanner();
      }));
    }
    selectProduct(handle, guests) {
      this.product = this.data.products.find(p => p.handle === handle); if (!this.product) return;
      const guestLimit = Math.max(0, ...this.product.variants.flatMap(v => v.options.map(value => Number(String(value).match(/up to\s+(\d+)\s+guests/i)?.[1] || 0))));
      this.customGuests = guests === 'large' || Number(guests) > guestLimit ? this.querySelector('[data-options="'+handle+'"] [data-enquiry-tier]')?.value || 'Custom guest count' : '';
      this.experience.value = handle;
      this.querySelectorAll('[data-options]').forEach(panel => panel.hidden = panel.dataset.options !== handle);
      this.panel = this.querySelector('[data-options="'+handle+'"]');
      const variants = this.product.variants || [];
      const matchesTier = v => (v.options || []).some(o => new RegExp('\\b'+guests+'\\b').test(o));
      const variant = guests ? variants.find(v => v.available && matchesTier(v)) || variants.find(matchesTier) : variants.find(v => v.available) || variants[0];
      if (variant) this.panel.querySelectorAll('[data-option]').forEach((select,i) => select.value = variant.options[i]);
      this.updateSummary();
    }
    updateSummary() {
      this.panel.querySelectorAll('[data-drink-choice],[data-option-choice]').forEach(choice => {
        choice.checked = this.customGuests && choice.closest('.oh-guest-choices') ? false : choice.value === this.panel.querySelector('#'+choice.dataset.selectId).value;
      });
      const customChoice = this.panel.querySelector('[data-enquiry-tier]');
      if (customChoice) customChoice.checked = Boolean(this.customGuests);
      const values = [...this.panel.querySelectorAll('[data-option]')].map(select => select.value);
      const variant = (this.product.variants || []).find(v => v.options.every((value,i) => value === values[i]));
      this.querySelector('[data-summary-service]').textContent = this.product.title;
      const options = [...this.panel.querySelectorAll('[data-option]')];
       const selected = name => options.find(el => el.dataset.optionName === name)?.value || '—';
       this.querySelector('[data-summary-guests]').textContent = this.customGuests || selected('Event guest count');
       this.querySelector('[data-summary-drinks]').textContent = selected('Drink selection');
       this.querySelector('[data-summary-setup]').textContent = this.panel.dataset.setup;
       const finishValue = selected('Finish') !== '—' ? selected('Finish') : selected('Drinkware') !== '—' ? selected('Drinkware') : selected('Setup selection');
       this.querySelector('[data-summary-finish]').textContent = /Glass/.test(finishValue) ? 'Glass' : 'Acrylic';
       const image = this.querySelector('[data-summary-image]');
       const styleImage = this.querySelector('[data-style-choice]:checked')?.closest('.oh-style-choice')?.querySelector('img');
       image.hidden = !styleImage; if (styleImage) { image.src = styleImage.src; image.alt = this.product.title; }
      this.querySelector('[data-summary-price]').textContent = this.customGuests ? 'Custom quote' : variant ? this.money.format(variant.price/100) : '—';
      this.querySelector('[data-availability]').textContent = this.customGuests ? 'Send an event enquiry for this guest count.' : !variant ? this.data.messages.noMatch : variant.available ? this.data.messages.available : this.data.messages.unavailable;
      this.selectedVariant = variant;
      this.querySelector('[data-add-cart]').disabled = Boolean(this.customGuests) || !variant?.available;
      this.querySelector('[data-add-cart]').hidden = Boolean(this.customGuests);
      this.querySelector('[data-open-enquiry]').hidden = Boolean(this.customGuests);
      const moreLink = this.querySelector('[data-more-enquiry]');
      moreLink.hidden = !this.customGuests;
      const enquiryUrl = new URL(moreLink.getAttribute('href').split('?')[0], location.origin);
      enquiryUrl.searchParams.set('service', this.product.title);
      enquiryUrl.searchParams.set('service_handle', this.product.handle);
      enquiryUrl.searchParams.set('guest_tier', this.customGuests || selected('Event guest count'));
      enquiryUrl.searchParams.set('finish', finishValue);
      enquiryUrl.searchParams.set('drinks', selected('Drink selection'));
      enquiryUrl.searchParams.set('setup', this.panel.dataset.setup);
      const event = this.eventDetails();
      for (const [key,value] of Object.entries(event)) if (value) enquiryUrl.searchParams.set(key,value);
      moreLink.href = enquiryUrl.toString();
      this.querySelector('[data-action-error]').hidden = true;
      this.querySelector('[data-upgrade-link]').href = this.product.url;
    }
    updateEventFinish() {
      const value = this.querySelector('[data-event-time]').value;
      const output = this.querySelector('[data-event-finish]');
      if (!value) { output.textContent = ''; return; }
      const start = Number(value.slice(0,2)) * 60 + Number(value.slice(3));
      const end = start + 180;
      const clock = total => String(Math.floor(total / 60) % 24).padStart(2,'0') + ':' + String(total % 60).padStart(2,'0');
      output.textContent = this.data.messages.finish + ' ' + clock(end) + (end >= 1440 ? ' ' + this.data.messages.nextDay : '');
    }
    validateEvent() {
      for (const field of this.querySelectorAll('[data-event-date],[data-event-time],[data-event-address],[data-event-suburb],[data-event-postcode]')) {
        if (!field.reportValidity()) { field.scrollIntoView({behavior:'smooth',block:'center'}); field.focus({preventScroll:true}); return false; }
      }
      return true;
    }
    eventDetails() {
      return {
        date:this.querySelector('[data-event-date]').value,
        time:this.querySelector('[data-event-time]').value,
        address:this.querySelector('[data-event-address]').value.trim(),
        suburb:this.querySelector('[data-event-suburb]').value.trim(),
        postcode:this.querySelector('[data-event-postcode]').value.trim()
      };
    }
    showActionError(message) {
      const output = this.querySelector('[data-action-error]');
      output.textContent = message; output.hidden = false;
    }
    async addSelectedPackage() {
      if (!this.selectedVariant?.available) { this.showActionError(this.data.messages.noMatch); return; }
      if (!this.validateEvent()) return;
      const button = this.querySelector('[data-add-cart]'), original = button.innerHTML;
      const event = this.eventDetails();
      button.disabled = true; button.textContent = this.data.messages.adding;
      this.querySelector('[data-action-error]').hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(this.selectedVariant.id),quantity:1,properties:{
            'Included drinks':this.data.messages.includedDrinks,'Event date':event.date,'Event start time':event.time,'Active hire ends':this.querySelector('[data-event-finish]').textContent,'Venue address':event.address,'Venue suburb':event.suburb,'Venue postcode':event.postcode
          }}]})
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || this.data.messages.cartError);
        window.location.assign(root + 'cart');
      } catch(error) {
        this.showActionError(error.message || this.data.messages.cartError);
        button.disabled = !this.selectedVariant?.available; button.innerHTML = original;
      }
    }
    populateEnquiry() {
      const event = this.eventDetails();
      const values = {
        service:this.product.title,
        guests:this.querySelector('[data-summary-guests]').textContent,
        drinks:this.querySelector('[data-summary-drinks]').textContent,
        setup:this.querySelector('[data-summary-setup]').textContent,
        finish:this.querySelector('[data-summary-finish]').textContent,
        price:this.querySelector('[data-summary-price]').textContent,
        date:event.date,time:event.time,address:event.address,suburb:event.suburb,postcode:event.postcode
      };
      for (const [key,value] of Object.entries(values)) {
        const field = this.querySelector('[data-enquiry-' + key + ']'); if (field) field.value = value;
      }
      const notes = this.querySelector('[data-enquiry-notes]').value.trim();
      this.querySelector('[data-enquiry-body]').value = [
        'Hosted experience: ' + values.service,
        'Guest package: ' + values.guests,
        'Drink selection: ' + values.drinks,
        'Setup: ' + values.setup,
        'Drinkware: ' + values.finish,
        'Selected package price: ' + values.price,
        'Shopify variant ID: ' + (this.selectedVariant?.id || 'No matching variant'),
        'Event date: ' + values.date,
        'Start time: ' + values.time,
        this.querySelector('[data-event-finish]').textContent,
        'Venue: ' + values.address + ', ' + values.suburb + ' ' + values.postcode,
        'Notes: ' + (notes || 'None')
      ].join(String.fromCharCode(10));
    }
    initPlannerStages() {
      this.planStage = 0;
      this.planSteps = [...this.querySelectorAll('.oh-plan-steps li')].map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        while (item.firstChild) button.append(item.firstChild);
        item.append(button);
        button.addEventListener('click', () => { if (index < this.planStage) this.showPlannerStage(index); });
        return button;
      });
      this.planNav = document.createElement('nav');
      this.planNav.className = 'oh-stage-navigation';
      this.planNav.setAttribute('aria-label', 'Booking steps');
      this.planBack = document.createElement('button');
      this.planNext = document.createElement('button');
      this.planBack.type = this.planNext.type = 'button';
      this.planBack.className = 'oh-button oh-button--secondary';
      this.planNext.className = 'oh-button';
      this.planBack.textContent = 'Back';
      this.planBack.addEventListener('click', () => this.showPlannerStage(this.planStage - 1));
      this.planNext.addEventListener('click', () => {
        if (this.planStage === 1 && !this.customGuests && !this.selectedVariant) return;
        if (this.planStage === 2 && !this.validateEvent()) return;
        this.showPlannerStage(this.planStage + 1);
      });
      this.planNav.append(this.planBack, this.planNext);
      this.querySelector('.oh-plan-grid').after(this.planNav);
      this.showPlannerStage(this.querySelector('.oh-enquiry-success,.oh-package-enquiry .oh-action-error') ? 3 : 0, false);
    }
    showPlannerStage(index, focus = true) {
      this.planStage = Math.max(0, Math.min(3, index));
      this.planDialog.dataset.stage = this.planStage;
      this.querySelector('.oh-style-choices').hidden = this.planStage !== 0;
      this.querySelector('.oh-options').hidden = this.planStage === 3;
      this.querySelector('.oh-summary').hidden = this.planStage !== 3;
      this.querySelector('.oh-event-details').hidden = this.planStage !== 2;
      this.querySelector('.oh-guidance').hidden = this.planStage !== 2;
      this.querySelector('.oh-extra').hidden = this.planStage !== 2;
      this.querySelectorAll('[data-options] fieldset').forEach(fieldset => { fieldset.hidden = this.planStage !== 1; });
      this.planSteps.forEach((button, i) => {
        button.disabled = i >= this.planStage;
        if (i === this.planStage) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      this.planBack.hidden = this.planStage === 0;
      this.planNext.hidden = this.planStage === 3;
      this.planNext.textContent = this.planStage === 2 ? 'Review package →' : 'Continue →';
      if (this.planStage === 3) {
        let review = this.querySelector('[data-hosted-event-review]');
        if (!review) {
          review = document.createElement('dl'); review.dataset.hostedEventReview = '';
          this.querySelector('.oh-summary dl').after(review);
        }
        review.replaceChildren();
        this.querySelectorAll('.oh-event-grid input,.oh-event-grid select').forEach(field => {
          const row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
          label.textContent = field.closest('label').firstChild.textContent.trim();
          value.textContent = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
          row.append(label, value); review.append(row);
        });
      }
      this.planDialog.scrollTop = 0;
      if (focus && this.planDialog.open) {
        const selector = ['.oh-style-choices legend', '[data-options]:not([hidden]) legend', '#oh-event-title', '#oh-summary-title'][this.planStage];
        const heading = this.querySelector(selector);
        heading?.setAttribute('tabindex', '-1'); heading?.focus({preventScroll:true});
      }
    }
    openPlanner() {
      if (!this.planDialog.open) this.planDialog.showModal();
    }
    showStep(focus) {
      this.steps.forEach((fieldset,i) => {fieldset.hidden=i!==this.step;fieldset.disabled=i!==this.step;});
      this.querySelector('[data-step-count]').textContent=this.step+1;
      this.querySelector('[data-back]').hidden=this.step===0;
      this.querySelector('[data-next]').hidden=this.step===2;
      this.querySelector('[data-finish]').hidden=this.step!==2;
      if(focus)this.steps[this.step].querySelector('legend').focus({preventScroll:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-self-serve-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-self-builder')) {
  customElements.define('olouioo-self-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.dialog = this.querySelector('[data-builder-dialog]');
      this.launch = this.querySelector('[data-builder-open]');
      this.openBuilder = () => { if (!this.dialog.open) this.dialog.showModal(); };
      this.launch.addEventListener('click', this.openBuilder);
      this.querySelector('[data-builder-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.launch.focus({preventScroll:true}));
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href="#oss-build"]');
        if (link) { event.preventDefault(); this.openBuilder(); }
      });
      this.initStages();
      this.data = JSON.parse(this.querySelector('[data-builder-data]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:this.data.currency || 'AUD'});
      this.querySelectorAll('[data-experience]').forEach(choice => choice.addEventListener('change', () => { if (choice.checked) this.select(choice.value); }));
      this.querySelectorAll('[data-option-choice]').forEach(choice => choice.addEventListener('change', () => this.update()));
      this.addEventListener('olouioo:table-details', () => this.update());
      this.querySelector('[data-add-cart]').addEventListener('click', () => this.addToCart());
      this.querySelector('[data-open-enquiry]').addEventListener('click', () => {
        const details = this.querySelector('[data-enquiry]'); details.open = true;
        this.querySelector('[data-open-enquiry]').setAttribute('aria-expanded','true');
        details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
        details.querySelector('[name="contact[name]"]')?.focus({preventScroll:true});
      });
      this.querySelector('[data-event-time]').addEventListener('change', () => this.updateFinish());
      const today = new Date();
      const eventDate = this.querySelector('[data-event-date]');
      this.querySelector('[data-event-date]').min = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0,10);
      const dateDisplay = this.querySelector('.ossb__date-display');
      const datePrompt = dateDisplay.textContent.trim();
      const syncDateDisplay = () => {
        dateDisplay.textContent = eventDate.value
          ? new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(eventDate.value + 'T00:00:00Z'))
          : datePrompt;
        dateDisplay.classList.toggle('is-selected', Boolean(eventDate.value));
      };
      eventDate.addEventListener('change', syncDateDisplay);
      eventDate.addEventListener('input', syncDateDisplay);
      syncDateDisplay();
      const mobileAction = document.querySelector('.oss-mobile-action');
      if (mobileAction && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => mobileAction.classList.toggle('is-builder-visible', entry.isIntersecting), {rootMargin:'0px 0px -80px 0px'}).observe(this);
      }
      const time = this.querySelector('[data-event-time]');
      for (let hour = 9; hour <= 21; hour++) for (const minute of [0,30]) {
        if (hour === 21 && minute === 30) continue;
        const option = document.createElement('option'); option.value = String(hour).padStart(2,'0')+':'+String(minute).padStart(2,'0');
        option.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:'UTC'}).format(new Date(Date.UTC(2020,0,1,hour,minute)));
        time.append(option);
      }
      this.querySelector('#SelfServePackageEnquiry')?.addEventListener('submit', event => {
        if (!this.validateEvent()) { event.preventDefault(); return; }
        this.populateEnquiry();
      });
      if (this.querySelector('.ossb__success,.ossb__enquiry .ossb__error')) this.querySelector('[data-enquiry]').open = true;
      this.select(this.querySelector('[data-experience]:checked')?.value || this.data.products.find(Boolean)?.handle);
      if (this.querySelector('.ossb__success,.ossb__enquiry .ossb__error')) this.showStage(3, false);
      if (location.hash === '#oss-build' || this.querySelector('.ossb__success,.ossb__enquiry .ossb__error')) this.openBuilder();
    }
    initStages() {
      this.stage = 0;
      this.stages = [...this.querySelectorAll('.ossb__steps li')];
      this.stagePanels = ['.ossb__styles','.ossb__config','.ossb__event','.ossb__summary'].map(selector => this.querySelector(selector));
      this.stageLabels = this.stages.map(item => item.textContent.trim().slice(2).trim());
      this.stageButtons = this.stages.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        while (item.firstChild) button.append(item.firstChild);
        button.addEventListener('click', () => { if (index < this.stage) this.showStage(index); });
        item.append(button);
        return button;
      });
      this.navigation = document.createElement('nav');
      this.navigation.className = 'ossb__stage-navigation';
      this.back = document.createElement('button');
      this.next = document.createElement('button');
      this.back.type = this.next.type = 'button';
      this.back.className = 'ossb__button ossb__button--outline';
      this.next.className = 'ossb__button';
      this.back.addEventListener('click', () => this.showStage(this.stage - 1));
      this.next.addEventListener('click', () => {
        if (this.stage === 0 && !this.product) return;
        if (this.stage === 1 && !this.variant) return;
        if (this.stage === 2 && !this.validateEvent()) return;
        this.showStage(this.stage + 1);
      });
      this.navigation.append(this.back,this.next);
      this.querySelector('.ossb__layout').after(this.navigation);
      this.classList.add('ossb--staged');
      this.showStage(0, false);
    }
    showStage(index, focus = true) {
      this.stage = Math.max(0, Math.min(3,index));
      this.stagePanels.forEach((panel, i) => { panel.hidden = i !== this.stage; });
      this.querySelector('.ossb__choices').hidden = this.stage === 3;
      this.querySelector('.ossb__included').hidden = this.stage !== 2;
      this.stageButtons.forEach((button, i) => {
        button.disabled = i >= this.stage;
        if (i === this.stage) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      this.back.hidden = this.stage === 0;
      this.next.hidden = this.stage === 3;
      this.back.textContent = '← ' + (this.stageLabels[this.stage - 1] || '');
      this.next.textContent = (this.stageLabels[this.stage + 1] || '') + ' →';
      if (this.stage === 3) {
        let details = this.querySelector('[data-review-event]');
        if (!details) {
          details = document.createElement('dl');
          details.dataset.reviewEvent = '';
          this.querySelector('[data-summary-options]').after(details);
        }
        details.replaceChildren();
        this.querySelectorAll('.ossb__event input,.ossb__event select').forEach(field => {
          const row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
          label.textContent = field.closest('label').firstChild.textContent.trim();
          value.textContent = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
          row.append(label,value);details.append(row);
        });
      }
      this.dialog.scrollTop = 0;
      if (focus && this.dialog.open) {
        const heading = this.stagePanels[this.stage].querySelector('legend,h3');
        heading?.setAttribute('tabindex','-1');
        heading?.focus({preventScroll:true});
      }
    }
    select(handle) {
      this.product = this.data.products.find(p => p?.handle === handle); if (!this.product) return;
      this.querySelectorAll('[data-experience]').forEach(choice => { choice.checked = choice.value === handle; });
      this.querySelectorAll('[data-product-options]').forEach(panel => { panel.hidden = panel.dataset.productOptions !== handle; });
      this.panel = this.querySelector('[data-product-options="'+handle+'"]');
      const first = this.product.variants.find(v => v.available) || this.product.variants[0];
      this.panel.querySelectorAll('[data-option-group]').forEach((group,index) => {
        const choices = [...group.querySelectorAll('[data-option-choice]')];
        const match = choices.find(choice => choice.value === first?.options[index]);
        (match || choices[0]).checked = true;
      });
      this.panel.querySelector('olouioo-table-colours')?.syncFromNative?.();
      this.update();
    }
    tableQuantity() {
      if (this.product?.handle !== 'la-table') return 1;
      const field = this.querySelector('[data-table-quantity] input[name="quantity"]');
      const count = Number(field?.value);
      return Number.isSafeInteger(count) && count > 0 ? count : 1;
    }
    selections() {
      return [...this.panel.querySelectorAll('[data-option-group]')].map(group => ({name:group.dataset.optionName,value:group.querySelector('[data-option-choice]:checked')?.value || ''}));
    }
    update() {
      const chosen = this.selections();
      const variant = this.product.variants.find(item => item.options.every((value,index) => value === chosen[index]?.value));
      this.variant = variant;
      this.querySelector('[data-summary-title]').textContent = this.product.title;
      const list = this.querySelector('[data-summary-options]'); list.replaceChildren();
      for (const option of [...chosen, ...this.tableDetails()]) {
        const row = document.createElement('div'), name = document.createElement('dt'), value = document.createElement('dd');
        name.textContent = option.name; value.textContent = option.value; row.append(name,value); list.append(row);
      }
      this.querySelector('[data-table-quantity]').hidden = this.product.handle !== 'la-table';
      const priceLabel = this.querySelector('[data-price-label]');
      priceLabel.textContent = this.product.handle === 'la-table' ? priceLabel.dataset.tableLabel : priceLabel.dataset.packageLabel;
      const image = this.querySelector('[data-summary-image]');
      const source = variant?.featured_image?.src || this.product.image;
      image.hidden = !source; if (source) { image.src = source; image.alt = this.product.title; }
      this.querySelector('[data-summary-price]').textContent = variant ? this.money.format(variant.price/100) : '—';
      this.querySelector('[data-availability]').textContent = !variant ? this.data.messages.noMatch : variant.available ? this.data.messages.available : this.data.messages.unavailable;
      this.querySelector('[data-add-cart]').disabled = !variant?.available;
      this.querySelector('[data-action-error]').hidden = true;
    }
    updateFinish() {
      const time = this.querySelector('[data-event-time]').value, output = this.querySelector('[data-finish]');
      if (!time) { output.textContent = ''; return; }
      const end = Number(time.slice(0,2))*60 + Number(time.slice(3)) + 360;
      output.textContent = this.data.messages.finish+' '+String(Math.floor(end/60)%24).padStart(2,'0')+':'+String(end%60).padStart(2,'0')+(end>=1440?' '+this.data.messages.nextDay:'');
    }
    eventValues() {
      return {date:this.querySelector('[data-event-date]').value,time:this.querySelector('[data-event-time]').value,address:this.querySelector('[data-event-address]').value.trim(),suburb:this.querySelector('[data-event-suburb]').value.trim(),postcode:this.querySelector('[data-event-postcode]').value.trim()};
    }
    validateEvent() {
      const tableCount = this.product.handle === 'la-table' ? this.querySelector('[data-table-quantity] input[name="quantity"]') : null;
      if (tableCount && !tableCount.checkValidity()) { this.showStage(3); tableCount.reportValidity(); tableCount.focus(); return false; }
      for (const field of this.querySelectorAll('[data-event-date],[data-event-time],[data-event-address],[data-event-suburb],[data-event-postcode]')) {
        if (!field.checkValidity()) {this.showStage(2);field.reportValidity();field.scrollIntoView({behavior:'smooth',block:'center'});field.focus({preventScroll:true});return false;}
      }
      return true;
    }
    showError(message) {const output=this.querySelector('[data-action-error]');output.textContent=message;output.hidden=false;}
    tableDetails() {
      return [...this.panel.querySelectorAll('[data-table-property]:checked')].map(input => ({name:input.dataset.tableProperty,value:input.value}));
    }
    async addToCart() {
      if (!this.variant?.available) {this.showError(this.data.messages.noMatch);return;}
      if (!this.validateEvent()) return;
      const button=this.querySelector('[data-add-cart]'), original=button.innerHTML, event=this.eventValues();
      button.disabled=true;button.textContent=this.data.messages.adding;this.querySelector('[data-action-error]').hidden=true;
      const properties={...(window.OlouiooEvents?.schedule(event,this.data.messages.nextDay,6) || {}),'_olouioo_duration_hours':'6','_olouioo_duration_mode':'self','Hire duration':'6 hours','Event duration':'6 hours active hire','Start time':event.time,'Event date':event.date,'Event start time':event.time,'Active hire ends':this.querySelector('[data-finish]').textContent,'Venue address':event.address,'Venue suburb':event.suburb,'Venue postcode':event.postcode};
      for (const option of [...this.selections(), ...this.tableDetails()]) properties[option.name]=option.value;
      if (this.product.handle === 'la-table') properties['Glasses per table'] = '8';
      try {
        const root=window.Shopify?.routes?.root || '/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.variant.id),quantity:this.tableQuantity(),properties}]})});
        const result=await response.json().catch(()=>({}));
        if (!response.ok) throw new Error(result.description || result.message || this.data.messages.cartError);
        window.location.assign(root+'cart');
      } catch(error) {this.showError(error.message || this.data.messages.cartError);button.disabled=!this.variant?.available;button.innerHTML=original;}
    }
    populateEnquiry() {
      const event=this.eventValues(), chosen=[...this.selections(), ...this.tableDetails()], price=this.querySelector('[data-summary-price]').textContent;
      const packageText=chosen.map(option=>option.name+': '+option.value).join(' | ') + (this.product.handle === 'la-table' ? ' | Tables: '+this.tableQuantity()+' | Glasses: '+(this.tableQuantity()*8) : '');
      const fields={experience:this.product.title,package:packageText,price,date:event.date,time:event.time,address:event.address,suburb:event.suburb,postcode:event.postcode};
      for (const [key,value] of Object.entries(fields)) {const input=this.querySelector('[data-enquiry-'+key+']');if(input)input.value=value;}
      const lines=['Self-serve experience: '+this.product.title,...chosen.map(option=>option.name+': '+option.value),'Selected package price: '+price,'Shopify variant ID: '+(this.variant?.id || 'No matching variant'),'Event date: '+event.date,'Start time: '+event.time,this.querySelector('[data-finish]').textContent,'Venue: '+event.address+', '+event.suburb+' '+event.postcode,'Notes: '+(this.querySelector('[data-enquiry-notes]').value.trim() || 'None')];
      this.querySelector('[data-enquiry-body]').value=lines.join(String.fromCharCode(10));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-table-colours"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-table-colours')) {
  customElements.define('olouioo-table-colours', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-table-property]')) {
          event.stopPropagation();
          this.dispatchEvent(new CustomEvent('olouioo:table-details', {bubbles:true}));
          return;
        }
        if (!event.target.matches('[data-table-colour]')) return;
        event.stopPropagation();
        const table = this.querySelector('[data-table-colour="1"]:checked')?.value;
        const floral = this.querySelector('[data-table-colour="2"]:checked')?.value;
        const native = this.nativeChoices().find(choice => {
          const parts = this.parts(choice.value);
          return parts[0] === table && parts[1] === floral;
        });
        if (!native) { this.syncFromNative(); return; }
        if (native.tagName === 'OPTION') {
          native.parentElement.value = native.value;
          native.parentElement.dispatchEvent(new Event('change', {bubbles:true}));
        } else {
          native.checked = true;
          native.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      this.syncFromNative();
    }
    nativeChoices() {
      const scope = this.closest('[data-option-group]') || this.closest('variant-picker');
      return [...scope.querySelectorAll('[data-table-native] input[type="radio"],[data-table-native] option')];
    }
    parts(value) {
      const parts = value.split(' / ');
      return [parts[0]?.trim(), parts[1]?.replace(/ florals$/i, '').trim()];
    }
    syncFromNative() {
      const selected = this.nativeChoices().find(choice => choice.checked || choice.selected);
      if (!selected) return;
      const parts = this.parts(selected.value);
      this.querySelectorAll('[data-table-colour]').forEach(choice => {
        choice.checked = choice.value === parts[Number(choice.dataset.tableColour) - 1];
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["olouioo-table-furniture"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('olouioo-table-furniture')) {
  customElements.define('olouioo-table-furniture', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-table-drinkware], [data-table-furniture]')) return;
        event.stopPropagation();
        const finish = this.querySelector('[data-table-drinkware]:checked')?.value;
        const furniture = this.querySelector('[data-table-furniture]:checked')?.value;
        const value = finish + (furniture === 'Yes' ? ' · Tables and chairs included' : '');
        const native = this.nativeChoices().find(choice => choice.value === value);
        if (!native) { this.syncFromNative(); return; }
        if (native.tagName === 'OPTION') {
          native.parentElement.value = value;
          native.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          native.checked = true;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.syncFromNative();
    }
    nativeChoices() {
      return [...(this.closest('variant-picker')?.querySelectorAll('[data-table-furniture-native] input[type="radio"], [data-table-furniture-native] option') || [])];
    }
    syncFromNative() {
      const native = this.nativeChoices().find(choice => choice.checked || choice.selected);
      if (!native) return;
      const finish = native.value.split(' · ')[0];
      const furniture = native.value.includes(' · Tables and chairs included') ? 'Yes' : 'No';
      this.querySelectorAll('[data-table-drinkware]').forEach(choice => { choice.checked = choice.value === finish; });
      this.querySelectorAll('[data-table-furniture]').forEach(choice => { choice.checked = choice.value === furniture; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
